import React, { Fragment } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { SITENAMEALIAS } from '../utils/init';
import { Link } from 'react-router-dom';


class Invoices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            pageNo: 1,
            noOfItemsPerPage: 20,
        };

    }


    render() {
        return (
            <Fragment>
                <div className="container-scroller">
                    <Sidebar />
                    <Header />
                    <div className="main-panel">
                       
                        <Footer />
                    </div>
                    <Loader show={this.state.showLoader} />
                </div>
            </Fragment>

        )
    }

    componentDidMount() {


    }

}



export default Invoices

